"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinService = void 0;
const types_1 = require("../shared/types");
const MissingScopeSpinError_1 = require("./errors/MissingScopeSpinError");
class SpinService {
    constructor(twoFactorManagementClient, loggingFacade) {
        this.twoFactorManagementClient = twoFactorManagementClient;
        this.loggingFacade = loggingFacade;
        this.isFirstVehicleWCar = (enrolledVehicles) => { var _a; return ((_a = enrolledVehicles[0]) === null || _a === void 0 ? void 0 : _a.devicePlatform) === types_1.DevicePlatform.WCAR; };
    }
    async getSpinAvailability(enrolledVehicles) {
        var _a, _b;
        try {
            const spinStateResponse = await this.twoFactorManagementClient.getSpinState(this.isFirstVehicleWCar(enrolledVehicles));
            return {
                isAvailable: spinStateResponse.spinState === 'DEFINED' || spinStateResponse.spinState === 'LOCKED',
                spinChangeLockTime: (_a = spinStateResponse.spinLockedWaitingTime) !== null && _a !== void 0 ? _a : 0,
                remainingTries: (_b = spinStateResponse.remainingTries) !== null && _b !== void 0 ? _b : 0,
            };
        }
        catch (e) {
            this.loggingFacade.error('Could not get spin availability', e);
            const hasMissingScopeError = e instanceof MissingScopeSpinError_1.MissingScopeSpinError;
            return { isAvailable: false, spinChangeLockTime: 0, remainingTries: 0, hasMissingScopeError };
        }
    }
    async changeSpin(currentSpin, newSpin, enrolledVehicles) {
        await this.twoFactorManagementClient.changeSpin(currentSpin, newSpin, this.isFirstVehicleWCar(enrolledVehicles));
    }
    async resetSpin(newSpin, enrolledVehicles) {
        await this.twoFactorManagementClient.resetSpin(newSpin, this.isFirstVehicleWCar(enrolledVehicles));
    }
    async verifySpin(currentSpin, enrolledVehicles) {
        return await this.twoFactorManagementClient.verifySpin(currentSpin, this.isFirstVehicleWCar(enrolledVehicles));
    }
}
exports.SpinService = SpinService;
//# sourceMappingURL=SpinService.js.map